import { PanelRow, ToggleControl, FormTokenField, Dropdown, Button, RangeControl } from '@wordpress/components'
import { dispatch, useSelect } from '@wordpress/data'
import { useState, useEffect } from '@wordpress/element';

import { __ } from '@wordpress/i18n'

export default ({price, priceIndex }) => {
    let priceData = price
    const { pricing_categories } = useSelect((select) => {
        return select('WPTravel/TripEdit').getAllStore()
    }, []);
    const { updateTripPricing } = dispatch('WPTravel/TripEdit');
    let addPricingCategory = () => {

        if ( pricing_categories.length > 0 ) {
            priceData.categories = [...priceData.categories, {
                id: pricing_categories[0].id,
                price_per: 'person',
                regular_price: 0,
                is_sale: false,
                sale_price: 0
            }];
            updateTripPricing(priceData, priceIndex)
        }
    }
    return  <PanelRow className="wp-travel-action-section wp-travel-add-new-category"><span></span><Button variant="secondary" onClick={() => addPricingCategory()}>{__('+ Add Category', 'wp-travel-pro') }</Button></PanelRow>

}